<template>
  <v-container>
    <v-layout>
      <v-flex xs12 sm6 offset-sm3 pt-5>
        <v-layout row v-if="error">
          <v-flex xs12>
            <app-alert @dismissed="onDismissed" :text="error.message" :color="error.colour"></app-alert>
          </v-flex>
        </v-layout>
        <h1 class="title font-weight-bold">Add documents &amp; details</h1>
        <p class="subheading pt-2">Upload your insurance documents here&hellip;</p>
        <add-document></add-document>
        <div v-if='documents.length > 0'>
        <p class="subheading">Documents uploaded:</p>
        <v-list v-if="documents.length>0" subheader dense class="transparent">
          <v-list-tile
            v-for="item in documents"
            :key="item.id"
            avatar
          >
            <v-list-tile-avatar>
              <v-icon @click="downloadFile(item.url)" :class="[item.iconClass]" color="secondary">insert_drive_file</v-icon>
            </v-list-tile-avatar>

            <v-list-tile-content
              @click="downloadFile(item.url)"
            >
              <v-list-tile-title v-html="item.documentName" style="cursor:pointer;"></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    depressed
                    small
                    fab
                    v-on="on"
                  >
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-tile
                    @click="downloadFile(item.url)"
                  >
                    <v-list-tile-title>View document</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    @click="deleteFile(item.id)"
                  >
                    <v-list-tile-title>Delete document</v-list-tile-title>
                  </v-list-tile>
                </v-list>
          </v-menu>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        </div>
        <p v-else class="subheading">Your documents will appear here when you add them.</p>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import AddDocument from '@/components/AddDocument'

export default {
  components: {
    AddDocument
  },
  data () {
    return {
      items: [
        { id: 1, title: 'Car insurance Certificate' },
        { id: 2, title: 'Policy Schedule Document' },
        { id: 3, title: 'Car insurance Certificate' },
        { id: 4, title: 'Policy Schedule Document' },
        { id: 5, title: 'Car insurance Certificate' },
        { id: 6, title: 'Policy Schedule Document' },
        { id: 7, title: 'Car insurance Certificate' },
        { id: 8, title: 'Policy Schedule Document' },
        { id: 9, title: 'Policy Schedule Document' },
        { id: 10, title: 'Car insurance Certificate' },
        { id: 11, title: 'Policy Schedule Document' },
        { id: 12, title: 'Car insurance Certificate' },
        { id: 13, title: 'Policy Schedule Document' }
      ]
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    documents () {
      return this.$store.getters.documents || []
    }
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    downloadFile (fileToDownload) {
      // console.log('clicked', fileToDownload)
      window.open(fileToDownload, '_blank')
      this.$ga.event('Documents', 'View document', 'View')

      // this.$refs.menutabs.slider()
      // known issue need to use expansion panel to get slider on load
      // https://github.com/vuetifyjs/vuetify/issues/1609
    },
    deleteFile (fileId) {
      // console.log('delete', fileId)
      this.$store.dispatch('removeDocument', { fileId: fileId }).then(response => {
        // file deleted
        this.$ga.event('Documents', 'Delete document', 'Delete')
        this.$store.dispatch('addNotification', { text: 'File deleted.', type: 'success' })
        this.$store.commit('setLoading', false)
      }).catch(error => {
        // An error happened.
        this.$store.commit('setError', error)
        this.$store.commit('setLoading', false)
        console.log('error', error)
      })
    },
    editFile (fileToDownload) {
      console.log('edit', fileToDownload)
    }
  }
}
</script>
